export default "__VITE_ASSET__CPbDl_hN__"